import { useMutation, type UseMutationResult, useQueryClient } from "@tanstack/react-query";
import type { ApiError, ApiResponse } from "../../../types/apiResponse";
import { createChartAccount } from "../api/createChartAccount";
import type { ChartAccountData } from "../types";
import withPrefix from "../../../helpers/useQueryPrefix";

export const useCreateChartAccount = (): UseMutationResult<ApiResponse<{ id: number }>, ApiError, ChartAccountData> => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: createChartAccount,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: withPrefix(['chart_accounts']) });
		}
	})
}
